/*
 * Copyright (c) 2016-2017 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _classCallCheck = require("/builds/9xb/sites/peracto3/jigsaw24services/jigsaw24.com/peracto.jigsaw24.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/9xb/sites/peracto3/jigsaw24services/jigsaw24.com/peracto.jigsaw24.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var forge = require('node-forge/lib/forge');

require('node-forge/lib/md');

require('node-forge/lib/sha1');

require('node-forge/lib/sha256');

module.exports = /*#__PURE__*/function () {
  /**
   * Creates a new MessageDigest.
   *
   * @param algorithm the algorithm to use.
   */
  function MessageDigest(algorithm) {
    _classCallCheck(this, MessageDigest);

    this.md = forge.md[algorithm].create();
  }

  _createClass(MessageDigest, [{
    key: "update",
    value: function update(msg) {
      this.md.update(msg, 'utf8');
    }
  }, {
    key: "digest",
    value: function digest() {
      return this.md.digest().toHex();
    }
  }]);

  return MessageDigest;
}();